import axios from './templateInstance'

const deleteDesignTemplate = async (id: string) => {
  try {
    const response: any = await axios.delete(`/design-templates/${id}`)
    return response?.data ?? response
  } catch (error) {
    console.error('Error deleting design template:', error)
    return null
  }
}

export default deleteDesignTemplate
